import { useContext, useEffect, useRef, useState } from "react";
import { isEqual } from "lodash";

import { StoreContext } from '../business/Provider';

export const useCurrentCompany = () => {
  const [company, setCompany] = useState(null);
  
  const previousCompanyInfoRef = useRef(null);

  const context = useContext(StoreContext);

  const {
    companyState: { companies: companyInfo },
  } = context;

  useEffect(() => {
    if (!isEqual(previousCompanyInfoRef.current, companyInfo)) {
      previousCompanyInfoRef.current = companyInfo;
      setCompany(companyInfo);
    }
  }, [companyInfo]);

  return company;
};
